var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNav4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#222222",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7674 13.7333C16.6111 13.5771 16.3992 13.4894 16.1782 13.4894C15.9572 13.4894 15.7453 13.5771 15.5891 13.7333L14.9999 14.3217C14.8461 14.4809 14.6622 14.6078 14.4589 14.6952C14.2556 14.7825 14.0369 14.8285 13.8156 14.8304C13.5943 14.8324 13.3748 14.7902 13.17 14.7064C12.9651 14.6226 12.779 14.4988 12.6226 14.3423C12.4661 14.1858 12.3423 13.9998 12.2585 13.7949C12.1747 13.5901 12.1325 13.3706 12.1345 13.1493C12.1364 12.928 12.1824 12.7093 12.2697 12.506C12.3571 12.3027 12.484 12.1188 12.6432 11.965L17.3349 7.27168C18.4457 7.01903 19.6078 7.12301 20.6561 7.56882C21.7044 8.01464 22.5854 8.77959 23.174 9.75492C23.7625 10.7302 24.0286 11.8663 23.9343 13.0015C23.8401 14.1368 23.3904 15.2134 22.6491 16.0783L20.8924 17.8575L16.7674 13.7325V13.7333ZM7.63405 8.72334C8.49635 7.86116 9.62423 7.31499 10.8354 7.17315C12.0465 7.03131 13.27 7.30207 14.3082 7.94168L11.4641 10.7867C10.8481 11.4015 10.4969 12.2328 10.4857 13.103C10.4744 13.9732 10.804 14.8133 11.4039 15.4438C12.0038 16.0743 12.8265 16.4451 13.6962 16.4771C14.5659 16.5091 15.4136 16.1997 16.0582 15.615L16.1782 15.5008L19.7141 19.0358L16.1782 22.5717C15.8657 22.8841 15.4418 23.0597 14.9999 23.0597C14.5579 23.0597 14.1341 22.8841 13.8216 22.5717L7.63322 16.3833C6.6175 15.3675 6.04688 13.9899 6.04688 12.5533C6.04688 11.1168 6.6175 9.73915 7.63322 8.72334H7.63405Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav4);
export default __webpack_public_path__ + "static/media/nav4.8436652fd1ef57fdd6672cd6b992b979.svg";
export { ForwardRef as ReactComponent };